export default function ValueProposition() {
  return (
    <section id="guide" className="w-full bg-background-100">
      <div className="px-6 md:px-10 py-14 md:py-20">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <span className="inline-block px-4 py-1.5 rounded-full border border-foreground-200 text-foreground-600 text-xs font-medium tracking-wide uppercase mb-5">
              Pourquoi ce site ?
            </span>
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
              Le Problème &amp; <span className="text-accent-500">La Solution</span>
            </h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12">
            <div className="bg-background-50 border border-background-200 rounded-xl p-6 md:p-8">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-4">
                <i className="ri-error-warning-line text-lg"></i>
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-3">Le Problème</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                La plupart des utilisateurs ne savent pas structurer efficacement un <strong className="text-foreground-800">hipobuy spreadsheet</strong>, ce qui entraîne une perte de temps considérable et une mauvaise organisation de leurs données. Sans guide approprié, les fonctionnalités avancées restent inexploitées.
              </p>
            </div>

            <div className="bg-background-50 border border-background-200 rounded-xl p-6 md:p-8">
              <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-4">
                <i className="ri-check-double-line text-lg"></i>
              </div>
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-3">La Solution</h3>
              <p className="text-foreground-600 text-sm leading-relaxed">
                Ce site fournit un système complet pour maîtriser le <strong className="text-foreground-800">hipobuy spreadsheet</strong>, étape par étape. Tutoriels détaillés, comparatifs avancés et analyses approfondies vous accompagnent vers une maîtrise totale de vos données.
              </p>
            </div>
          </div>

          <div className="mt-12">
            <div className="bg-background-50 border border-background-200 rounded-xl p-6 md:p-8">
              <h3 className="font-heading text-xl font-semibold text-foreground-900 mb-6 text-center">
                Pourquoi ce site est différent
              </h3>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {[
                  { icon: 'ri-search-eye-line', title: 'Analyse Complète', desc: 'Comprendre chaque fonction du hipobuy spreadsheet en profondeur.' },
                  { icon: 'ri-scales-3-line', title: 'Comparaisons', desc: 'Hipobuy vs Excel vs Notion — tous les comparatifs détaillés.' },
                  { icon: 'ri-seo-line', title: 'Structure SEO-Ready', desc: 'Optimisé pour le classement Google avec contenu structuré.' },
                  { icon: 'ri-file-copy-line', title: 'Templates', desc: 'Modèles prêts à l\'emploi pour gagner du temps immédiatement.' },
                ].map((item) => (
                  <div key={item.title} className="text-center">
                    <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mb-3">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <h4 className="font-semibold text-foreground-800 text-sm mb-1">{item.title}</h4>
                    <p className="text-foreground-500 text-xs leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}